import {useState} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useError from '../../hooks/useError';
import useUser from "../../hooks/useUser";
import {useCreateCaseMutation} from "../../redux/services/caseApi";
import AppDashboard from "../AppDashboard";
import CaseForm from "../../components/cases/CaseForm";

const NewCasePage = props => {
  const [submitting, setSubmitting] = useState(false);
  const [createCase] = useCreateCaseMutation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = useUser();
  const providerId = user?.provider?.id;
  const patientId = searchParams.get('patientId') || null;
  const {create: setError} = useError();
  return (
    <AppDashboard title='New Case' loading={false}>
      <CaseForm 
        disabled={submitting}
        requirePatientSex={true}
        patientId={patientId}
        editing={false}
        afterSubmit={() => navigate('/providers/cases')}
      />
    </AppDashboard>
  );
};

export default NewCasePage;